import { Backdrop, CircularProgress } from "@material-ui/core"

const NCLoader = props => {
  return (
    <Backdrop
      style={{ color: "#fff", zIndex: "999999 !important" }}
      open={props.open}
      onClick={props.handleClose}
    >
      <CircularProgress />
    </Backdrop>
  )
}

export default NCLoader
